import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const twilioActions = createActions(
  {
    TWILIO_MAKE_CALL: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TWILIO_MAKE_CALLBACK: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TWILIO_MAKE_INTERNAL_CALL: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TWILIO_INIT: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TWILIO_SEND_DIGITS: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TWILIO_CLOSE: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TWILIO_CONNECT_CALL: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TWILIO_DISCONNECT_CALL: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TWILIO_FEEDBACK: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },
  'TWILIO_MAKE_CALL_SUCCEEDED',
  'TWILIO_MAKE_CALL_FAILED',

  'TWILIO_MAKE_CALLBACK_SUCCEEDED',
  'TWILIO_MAKE_CALLBACK_FAILED',

  'TWILIO_MAKE_INTERNAL_CALL_SUCCEEDED',
  'TWILIO_MAKE_INTERNAL_CALL_FAILED',

  'TWILIO_INIT_SUCCEEDED',
  'TWILIO_INIT_FAILED',

  'TWILIO_SEND_DIGITS_SUCCEEDED',
  'TWILIO_SEND_DIGITS_FAILED',

  'TWILIO_CLOSE_SUCCEEDED',
  'TWILIO_CLOSE_FAILED',

  'TWILIO_CONNECT_CALL_SUCCEEDED',
  'TWILIO_CONNECT_CALL_FAILED',

  'TWILIO_DISCONNECT_CALL_SUCCEEDED',
  'TWILIO_DISCONNECT_CALL_FAILED',

  'TWILIO_FEEDBACK_SUCCEEDED',
  'TWILIO_FEEDBACK_FAILED',

  'TWILIO_FEEDBACK_OPEN_MODAL',
  'TWILIO_FEEDBACK_CLOSE_MODAL',

  'TWILIO_CHANGE_DEVICE_STATUS',
  'TWILIO_DEVICE_ERROR',
  'TWILIO_ADD_ACTIVE_CALL',
  'TWILIO_ESTABLISHED_CALL',
  'TWILIO_MISSED_CALL',
  'TWILIO_DISCONNECTED_CALL',
);
